import React from 'react';

export default function Textarea({ label, className = '', ...props }) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && <label className="text-sm font-medium text-dark-green">{label}</label>}
      <textarea 
        className="px-4 py-3 rounded-md border border-amber bg-cream focus:outline-none focus:ring-2 focus:ring-forest-green transition-all resize-y min-h-[120px]"
        {...props}
      />
    </div>
  );
}